"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkFolders = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var ModeSelection_1 = require("./components/ModeSelection");
var SelectableFolders_1 = require("./components/SelectableFolders");
var StatusBox_1 = require("./components/StatusBox");
var dispatchers_1 = require("./utils/dispatchers");
var getlinkFoldersState = function (state) {
    return state.vektorio.linkFolders;
};
var getFolderTreeState = function (state) {
    return state.vektorio.folderTree.data;
};
require("./index.scss");
var LinkFolders = function (props) {
    var linkFoldersState = (0, react_redux_1.useSelector)(getlinkFoldersState);
    var folderTreeState = (0, react_redux_1.useSelector)(getFolderTreeState);
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    var SyncIcon = React.createElement(sok_ui_1.Icon, { className: 'fa-sync' });
    var CloseIcon = React.createElement(sok_ui_1.Icon, { className: 'fa-times-circle' });
    var filterSelected = function (node) { return node.getSelected(); };
    var getValue = function (node) { return node.getValue(); };
    var linkFolders = function () {
        var _a, _b;
        return dispatchers.linkFolders({
            mode: linkFoldersState.mode,
            project: props.currentProject,
            vektorio: props.vektorioProject,
            folders: (_b = (_a = folderTreeState.tree) === null || _a === void 0 ? void 0 : _a.getNodes().filter(filterSelected).map(getValue)) !== null && _b !== void 0 ? _b : []
        });
    };
    var handleUnmount = function () {
        if (linkFoldersState.isOpen === false) {
            dispatchers.clear();
        }
    };
    React.useEffect(handleUnmount, [linkFoldersState.isOpen]);
    return (React.createElement(sok_ui_1.Overlay, { isOpen: linkFoldersState.isOpen },
        React.createElement(sok_ui_1.SideMenu, { className: 'vektorio-link-folders-sidemenu', isOpen: linkFoldersState.isOpen, docked: false, orientation: 'right' },
            React.createElement(sok_ui_1.Header, { onClose: props.onClose }, (0, translation_1.getLocalization)('vektorio/linkFolder/heder')),
            React.createElement(sok_ui_1.Container, null,
                React.createElement(StatusBox_1.StatusBox, { status: linkFoldersState.status, prefix: 'vektorio/linkFolders/status' }),
                React.createElement("div", { className: 'disclaimer' }, (0, translation_1.getLocalization)("vektorio/linkFolders/disclaimer")),
                React.createElement("h3", null, (0, translation_1.getLocalization)("vektorio/linkFolders/header/vektorio")),
                React.createElement(ModeSelection_1.ModeSelection, null),
                React.createElement("h3", null, (0, translation_1.getLocalization)("vektorio/linkFolders/header/sokopro")),
                React.createElement(SelectableFolders_1.SelectableFolders, { currentProject: props.currentProject })),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement(sok_ui_1.Button, { color: 'green', iconRight: SyncIcon, onClick: linkFolders }, (0, translation_1.getLocalization)('vektorio/sync')),
                React.createElement(sok_ui_1.Button, { color: 'dark-gray', iconRight: CloseIcon, onClick: props.onClose }, (0, translation_1.getLocalization)('buttons/close'))))));
};
exports.LinkFolders = LinkFolders;
